import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$x.dateFormWrap }, [
    _c(
      "div",
      { class: _vm.$x.dateForm },
      [
        _c(
          VForm,
          { ref: "dateForm", attrs: { name: "dateForm" } },
          [
            _c("NsCreditCardDate", {
              staticClass: "date-field",
              attrs: {
                translations: _vm.t.creditCardDate,
                "field-disabled": _vm.disableDate,
              },
              on: {
                input: _vm.updateExpireDate,
                "date-valid-state": _vm.setValid,
              },
              model: {
                value: _vm.cardDate,
                callback: function ($$v) {
                  _vm.cardDate = $$v
                },
                expression: "cardDate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          VBtn,
          {
            staticClass: "v-btn-hit-solid short",
            class: _vm.$x.formContinue,
            attrs: { name: "selectCvv", loading: _vm.loading },
            on: { click: _vm.doContinue },
          },
          [_vm._v("\n      " + _vm._s(_vm.t.continue) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }